import ScreenLock from '../__utils/screenLock';
import Search from '../__page/Search';
import InpageNav from '../__page/InpageNav';
import MegaMenu from './MegaMenu';

const $ = jQuery.noConflict();

class Header {
    constructor() {
        this.body = $('body');
        this.header = $('.main-header');
        this.alertBar = this.header.find('#header-alert-bar');
        this.menu = this.header.find('.main-header__menu');
        this.menuTrigger = this.header.find('.main-header__menu-trigger');

        // Variables
        this.mq = window.matchMedia('(max-width: 1199px)');
    }

    init() {
        this.resized();

        this.menuTrigger.on('click', this.toggleMenu.bind(this));

        if (this.alertBar.length) {
            this.alertBar.find('.alert-bar__close').on('click', () => {
                this.setAlertCookie()
                $('body').removeClass('alert-bar-on');
                this.alertBar.remove();
                this.resized();
                InpageNav.scrolled(true);
            });
        }

        this.mq.addListener((mq) => {
            if (mq.matches) this.closeMenu();
        });
    }

    setAlertCookie() {
        var now = new Date();
        var time = now.getTime();
        time += 24 * 3600 * 1000; // 24 hours
        now.setTime(time);
        document.cookie = 
            'hideAlertBar=1' + 
            '; expires=' + now.toUTCString() + 
            '; path=/';
    }

    toggleMenu() {
        if (this.menuTrigger.hasClass('active')) {
            this.closeMenu();
        } else {
            this.openMenu();
        }
    }

    openMenu() {
        this.body.addClass('menu-open');
        Search.closeSearch();
        ScreenLock.lock();
        this.menuTrigger.addClass('active').children('.text').text(this.menuTrigger.data('close'));
        this.menu.addClass('active');
        this.setMenuHeight();
    }

    closeMenu() {
        this.body.removeClass('menu-open');
        this.menuTrigger.removeClass('active').children('.text').text(this.menuTrigger.data('open'));
        this.menu.removeClass('active');
        MegaMenu.hideMegaMenu();
        ScreenLock.unlock();
    }

    setMenuHeight() {
        if (this.mq.matches) {
            return;
        }

        //const height = window.innerHeight - this.header.outerHeight();

        //this.menu.css('height', height);
    }

    resized() {
        this.setMenuHeight();
    }

    keyDown(e) {
        if (e.keyCode === 27 && this.menu.hasClass('active')) {
            this.closeMenu();
        }
    }
}

export default new Header();
